import React from 'react'
import header from './HeaderContact.module.scss'
import HeaderButton from '../../components/HeaderButton/HeaderButton'

const HeaderContact = ({isRus, enable}) => {

    return (
        <div className={header.contacts}>
            <HeaderButton/>
            <div className={header.box_phone}>
                <a className={header.phone}  href="tel:+79037551472" target='_blank' rel='noopener noreferrer'>+7 (903) 755-14-72</a>
            </div>
            <div className={header.button} >
                <p className={header.language} onClick={enable}>{isRus ? 'EN' : 'RU'}</p>
            </div>
        </div>
    );
};

export default HeaderContact